export default __webpack_public_path__ + "static/media/banners_buenfin_coche_2_330x330.6d86f414.jpg";